"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataPoint = void 0;
const utils_1 = require("ethers/lib/utils");
const Serializable_1 = require("../common/Serializable");
const utils_2 = require("../common/utils");
class DataPoint extends Serializable_1.Serializable {
    constructor(dataFeedId, value) {
        super();
        this.dataFeedId = dataFeedId;
        this.value = value;
    }
    serializeDataFeedId() {
        return (0, utils_2.convertStringToBytes32)(this.dataFeedId);
    }
    toObj() {
        return {
            dataFeedId: this.dataFeedId,
            value: utils_1.base64.encode(this.value),
        };
    }
    getValueByteSize() {
        return this.value.length;
    }
    toBytes() {
        const serializeddataFeedId = this.serializeDataFeedId();
        return (0, utils_1.concat)([serializeddataFeedId, this.value]);
    }
}
exports.DataPoint = DataPoint;
//# sourceMappingURL=DataPoint.js.map